import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminDashboard from './components/AdminDashboard';
import UserDashboard from './components/UserDashboard';
import Header from './components/Header';
import Auth from './components/Auth';
import AboutUs from './components/AboutUs';
import Features from './components/Features';

const App = () => {
    return (
        <Router>
            <div>
                <Header />
                <Routes>
                    <Route path="/" element={<AboutUs />} />
                    <Route path="/auth" element={<Auth />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/features" element={<Features />} />
                    <Route path="/admin-dashboard" element={<AdminDashboard />} />
                    <Route path="/user-dashboard" element={<UserDashboard />} />
                </Routes>
            </div>
        </Router>
    );
};

export default App;
